<template>
  <div class="container">

    <div class="columns is-desktop">

      <div class="column is-half is-offset-one-quarter">

        <figure class="image">
          <img src="../assets/logo-white.png" alt="HelixChart" style="max-width:400px;margin:3rem auto;padding: 0 15px;display: block;">
        </figure>

        <div class="card" style="margin-top:50px;">
          <div class="card-content">

              <h2 class="title is-2">Create an Account</h2>

                <label class="label">Email</label>
                <b-field>
                    <b-input
                        type="email"
                        placeholder="youremail@email.com"
                        v-model="email"
                        required>
                    </b-input>
                </b-field>

                <label class="label">Password</label>
                <b-field>
                    <b-input
                        v-model="password"
                        type="password"
                        password-reveal
                        required>
                    </b-input>
                </b-field>

                <label class="label">Verify Password</label>
                <b-field>
                    <b-input
                        v-model="verifyPassword"
                        type="password"
                        password-reveal
                        required>
                    </b-input>
                </b-field>

                <label class="label">Code</label>
                <b-field>
                    <b-input
                        type="text"
                        v-model="betaCode">
                    </b-input>
                </b-field>

                <div class="field">
                  <p class="control">
                    <button @click="isFormValid" class="button is-success">
                      Sign Up
                    </button>
                  </p>
                </div>

                <div class="field">
                  <p class="control">
                    <router-link to="/login">Back to Login</router-link>
                  </p>
                </div>


          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import betaCodes from '@/utils/betaCodes';
import firebase from 'firebase';

export default {
  name: 'Register',
  data() {
    return {
      email: '',
      password: '',
      verifyPassword: '',
      betaCode: '',
      currentUser: null,
      betaCodes,
    };
  },
  methods: {
    getCurrentUser() {
      this.currentUser = firebase.auth().currentUser;
    },
    isValidPassword() {
      return (this.password === this.verifyPassword &&
              this.password.length > 3) || false;
    },
    isBetaValid() {
      return this.betaCodes.find(code => code == this.betaCode);
    },
    isFormValid() {
      if (this.isBetaValid()) {
        if (this.email.length > 1) {
          if (this.isValidPassword()) {
            this.register();
          } else {
            this.$toast.open({
              message: 'Passwords do not match or password is too short.',
              position: 'is-bottom',
              type: 'is-danger',
            });
          }
        } else {
          this.$toast.open({
            message: 'Email is required.',
            position: 'is-bottom',
            type: 'is-danger',
          });
        }
      } else {
        this.$snackbar.open({
          message: 'Please provide a code to access HelixChart. Issues registering? Contact support@helixchart.com.',
          type: 'is-warning',
          position: 'is-top',
          actionText: 'Ok',
          indefinite: true,
        });
      }
    },
    registerSuccess() {
      this.$router.replace('projects');
      this.$toast.open({
        message: 'Account successfully created. Welcome to HelixChart!',
        duration: 3000,
        position: 'is-bottom',
        type: 'is-success',
      });
    },
    register() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.getCurrentUser();
          var firstLoginDate = Date.now();

          // set beta user
          var updates = {};
          updates['/users/' + this.currentUser.uid + '/plan'] = 'beta';
          updates['/users/' + this.currentUser.uid + '/registered'] = firstLoginDate;
          firebase.database().ref().update(updates).then(() => {
            this.registerSuccess();
          });

        }, (error) => {
          this.$toast.open({
            message: 'Error creating account. Please check back and try again later.',
            position: 'is-bottom',
            type: 'is-danger',
          });
        });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue